<template>
	<div class="checkInQuery">
    <!-- 固定栏 -->
    <div class="fixed-content">
      <!-- tabBtn -->
      <div class="tabBtn">
        <mt-navbar class="navBar" v-model="selected">
          <mt-tab-item class="tabBtnNav1" id="1">宿舍报修</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="2">其他报修</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="3">我的报修</mt-tab-item>
        </mt-navbar>
      </div>
    </div>

    <!-- 内容栏 -->
      <div v-if="selected == 1" class="scroll-content scroll-content1">
        <div class="tabContent margin-lr-30">
          <div class="mesList padding-20 bg-fff">
            <div class="title titleMes color-333 font-size-14px margin-top-10">
              <div class="leftMes">
                <span>报修人：</span>
                <span class="color-666">{{initMaintainIndex.personName}} </span>
              </div>
              <div class="rightMes">
                <span class="color-333">上网账号：</span>
                <span class="margin-left-20 color-666">{{initMaintainIndex.personNo}}</span>
              </div>
            </div>
            <div class="title titleMes color-333 font-size-14px margin-top-10">
              <div class="leftMes">
                <span>宿舍楼栋：</span>
                <span class="color-666">{{initMaintainIndex.address}} </span>
              </div>
              <div class="rightMes">
                <span class="color-333">-房间号:</span>
                <span class="margin-left-20 color-666">{{initMaintainIndex.roomNo}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="item-input">
            <p class="label">*报修人</p>
            <p class="input-text font-size-28" style="width: 100%;">{{initMaintainIndex.personName}}</p>
          </div>

          <div class="item-input">
            <p class="label">*学号／工号</p>
            <p class="input-text font-size-28" style="width: 100%;">{{initMaintainIndex.personNo}}</p>
          </div>

          <div class="item-input">
            <p class="label">*宿舍楼栋</p>
            <p class="input-text font-size-28" style="width: 100%;">{{initMaintainIndex.address}}</p>
          </div>
          <div class="item-input">
            <p class="label">*房间号</p>
            <p class="input-text font-size-28" style="width: 100%;">{{initMaintainIndex.roomNo}}</p>
          </div> -->

          <div class="subTitle margin-top-20">*请选择床位</div>

          <div class="rooms">
            <div class="textDes">宿舍入口</div>
            <div class="allBed">
              <div class="bed" @click="chooseBed(1)" :class="{ 'bg-appStyle color-fff': bedNum == 1 }">1号床</div>
              <div class="bed" @click="chooseBed(2)" :class="{ 'bg-appStyle color-fff': bedNum == 2 }">2号床</div>
              <div class="bed" @click="chooseBed(3)" :class="{ 'bg-appStyle color-fff': bedNum == 3 }">3号床</div>
              <div class="bed" @click="chooseBed(4)" :class="{ 'bg-appStyle color-fff': bedNum == 4 }">4号床</div>
            </div>
            <div class="textDes">厕所阳台</div>
          </div>

          <div class="item-input margin-top-20">
            <p class="label">*联系电话</p>
            <input class="input-text font-size-28" type="number" placeholder="请填写联系电话" v-model="bxTel" style="width: 100%;">
          </div>
          <div class="margin-top-10 color-tipRed font-size-26">注意：若是融合套餐用户请输入电信融合套餐手机号。</div>

          <div class="subTitle margin-top-20">*请选择故障</div>
          <div class="gzBoxs">
            <div class="box bg-no" @click="chooseWired('wired')" :class="{ 'bg-fff color-appStyle': wired == 'wired' }">有线</div>
            <div class="box bg-no" @click="chooseWired('wireless')" :class="{ 'bg-fff color-appStyle': wired == 'wireless' }">无线</div>
          </div>
          <div class="gzBoxs">
            <div class="box" v-for="(item, index) in gzList" :key="index" @click="chooseGz(item)" :class="{ 'bg-appStyle color-fff': item.isChoose }">{{item.name}}</div>
          </div>

          <div class="subTitle margin-top-20">问题描述</div>
          <div class="bg-fff">
            <textarea  class="HqTextarea font-size-28 full-width margin-top-10" elastic placeholder="请您对故障情况做简单描述(选填)" maxlength="100" v-model="wentiDes"></textarea>
          </div>
        </div>

      </div>

      <div v-if="selected == 2" class="scroll-content scroll-content1">
        <div class="tabContent margin-lr-30">
          <div class="mesList padding-20 bg-fff">
            <div class="title color-333 font-size-14px margin-top-10">
              <span>报修人：</span>
              <span class="color-666">{{initMaintainIndex.personName}} </span>
              <span class="color-333">上网账号：</span>
              <span class="margin-left-20 color-666">{{initMaintainIndex.personNo}}</span>
            </div>
            <!-- <div class="title color-333 font-size-14px margin-top-10">
              <span>宿舍楼栋：</span>
              <span class="color-666">{{initMaintainIndex.address}} </span>
              <span class="color-333">-房间号:</span>
              <span class="margin-left-20 color-666">{{initMaintainIndex.roomNo}}</span>
            </div> -->
          </div>

          <div class="item-input">
            <p class="label">*报修位置</p>
            <input class="input-text font-size-28" type="text" placeholder="请填写报修位置" v-model="bxLocation" style="width: 100%;">
          </div>

          <div class="item-input margin-top-20">
            <p class="label">*联系电话</p>
            <input class="input-text font-size-28" type="number" placeholder="请填写联系电话" v-model="bxTel" style="width: 100%;">
          </div>

          <div class="margin-top-10 color-tipRed font-size-28">注意：若是融合套餐用户请输入电信融合套餐手机号。</div>

          <div class="subTitle margin-top-20">*请选择故障</div>
          <div class="gzBoxs">
            <div class="box bg-no" @click="chooseWired('wired')" :class="{ 'bg-fff color-appStyle': wired == 'wired' }">有线</div>
            <div class="box bg-no" @click="chooseWired('wireless')" :class="{ 'bg-fff color-appStyle': wired == 'wireless' }">无线</div>
          </div>
          <div class="gzBoxs">
            <div class="box" v-for="(item, index) in gzList" :key="index" @click="chooseGz(item)" :class="{ 'bg-appStyle color-fff': item.isChoose }">{{item.name}}</div>
          </div>

          <div class="subTitle margin-top-20">问题描述</div>
          <div class="bg-fff">
            <textarea  class="HqTextarea font-size-28 full-width margin-top-10" elastic placeholder="请您对故障情况做简单描述(选填)" maxlength="100" v-model="wentiDes"></textarea>
          </div>
        </div>
      </div>

      <div v-if="selected == 3" class="scroll-content scroll-content1">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
          <div class="noData" v-if="list.length == 0">
              <div style="padding-bottom: 7rem;">
                  <img src="static/images/default-null.png"  alt="">
                  <p>暂时无相关数据</p>
              </div>
          </div>
          <div class="padding-20 bg-fff margin-top-20" @click="openPage('RepairApplyDetial', item)" v-for="(item, index) in list" :key="index">
            <div class="listBox">
              <div class="mesList">
                <div class="title color-333 font-size-14px">报修时间：{{item.reportTime}}</div>
                <p class="color-666 font-size-26 margin-top-8">报修类型：{{item.reportType}}</p>
                <p class="color-666 font-size-26 margin-top-8">姓名：{{item.reporterName}}</p>
                <p class="color-666 font-size-26 margin-top-8">上网账号：{{item.reporterNumber}}</p>
                <p class="color-666 font-size-26 margin-top-8">报修位置：{{item.location}}</p>
                <p class="color-666 font-size-26 margin-top-8">报修原因：{{item.reportCause}}</p>
                <p class="color-666 font-size-26 margin-top-8">联系电话：{{item.reporterPhone}}</p>
              </div>
              <!-- <img class="typeStateBtn" v-if="item.orderStatusName == '待分配'" src="static/images/dsh.png"> -->
              <p class="typeStateBtn color-fff" 
              :class="{ 'bg-f9b625': item.orderStatusName == '待分配' }">{{item.orderStatusName}}</p>
            </div>
            <div class="border-top handleBoxs" v-if="item.reportOrderButtons.length > 0">
              <div class="handleBtn color-fff" v-for="(btnItem, key) of item.reportOrderButtons" :key="key" @click="closeItem($event, btnItem, item)">{{btnItem}}</div>
            </div>
            <!-- <div class="border-top handleBoxs" v-if="item.audit2Status == '待分配'">
              <div class="handleBtn color-fff" @click="closeItem($event, item)">撤销申请</div>
            </div>
            <div class="border-top handleBoxs" v-if="item.audit2Status == '待分配'">
              <div class="handleBtn color-fff" @click="closeItem($event, item)">未修好</div>
            </div>
            <div class="border-top handleBoxs" v-if="item.audit2Status == '待分配'">
              <div class="handleBtn color-fff" @click="closeItem($event, item)">确认完成</div>
            </div> -->
          </div>
        </mt-loadmore>
      </div>

      <div class="footerBtn" v-if="selected != 3" >
        <div class="btn bg-appStyle" @click="cancel()">取消</div>
        <div class="btn bg-appStyle" @click="submit()">提交</div>
      </div>

      <!-- 弹出框 -->
      <v-messagebox v-if="showMesBox" :mes-box-title="mesBoxTitle" :mes-box-type="mesBoxType" @change="mesBosChange"></v-messagebox>
    </div>

</template>

<script>

import Vue from 'vue'
import { mapGetters } from "vuex";
import { Navbar, TabItem } from 'mint-ui';
import { Loadmore } from 'mint-ui';
import { InfiniteScroll } from 'mint-ui';
import MobileSelect from 'mobile-select';
import { Toast } from 'mint-ui';
import { MessageBox } from 'mint-ui';
import api from "../fetch/api";
import {checkPhone} from '@/util/filter'
import messagebox from "@/components/messagebox";


import service from "@/fetch/service";
import * as types from '@/vuex/types';
export default {
  components: {
    Navbar,
    TabItem,
    'v-messagebox': messagebox
  },
  data() {
    return {
      Url: types.URL,
      initMaintainIndex: {}, //学生初始化的数据
      selected: '1', //默认当前的tab 页面
      pageNo: 1, //分页
      pageSize: 20, //每次请求的个数
      allLoaded: true,//是否加载完毕
      haveMore: true, //是否有更多数据
      bxTel: '', // 报修电话
      wentiDes: '', // 问题描述
      list: [], //数据
      wired: 'wired', //选择有线还是♾
      gzList: [],
      bedNum: '', //当前选择的bed
      bxLocation: '', //保修位置 当selected为2时
      showMesBox: false, //是否显示弹出框
      mesBoxType: 5, // 5：满意度调查
    };
  },
  created() {
    this.getMes();
    
    // MessageBox('重庆大学虎溪校区网络升级临时断网的通知', '<p class="text-left">虎溪校区网络用户：</p><p class="text-left" style="text-indent:20px;">  由于重庆大学虎溪校区网络主干设备更新升级，将于2020年12月30日（周三）12:20—13:00对全校区实施临时断网。请虎溪校区网络用户提前做好工作和学习安排。</p><p class="text-left" style="text-indent:20px;">特此通告，敬请各位用户相互转告。</p>');
  },
  computed: {
    ...mapGetters([])
  },
  mounted() {
    let that = this
  },
  watch: {
    'selected': function() {
      this.list = [];
      this.pageNo = 1;
      this.loaddata(); 
    }
  },
  methods: {
    //获取学生信息
    getMes() {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      service
      .initMaintainIndex({
        indexType: this.selected
      })
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        if (res.success) {
          that.initMaintainIndex = res.result;
          that.bxLocation = res.result.lastAddress;
          that.bxTel = res.result.lastReporterPhone;
          console.log(that.bxTel)
          console.log(that.initMaintainIndex)
          res.result.faultTypes.wired.forEach(element => {
            that.gzList.push({
              name: element.name,
              isChoose: false
            })
          });
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.msg);
      });
    },
    chooseBed: function (id) {
      if (id != this.bedNum) {
        this.bedNum = id
      }
    },
    chooseWired: function (typeName) {
      let that = this
      that.gzList = [];
      that.wired = typeName;
      if (typeName == 'wired') {
        that.initMaintainIndex.faultTypes.wired.forEach(element => {
          that.gzList.push({
            name: element.name,
            isChoose: false
          })
        });
      }else {
        that.initMaintainIndex.faultTypes.wireless.forEach(element => {
          that.gzList.push({
            name: element.name,
            isChoose: false
          })
        });
      }
    },
    chooseGz: function (item) {
      if (item.isChoose) {
        item.isChoose = false;
      }else{
        item.isChoose = true;
      }
    },
    /**
     * 取消 清空数据
     */
    cancel: function () {
      let that = this;
      MessageBox.confirm('确定执行此操作?').then(action => {
        console.log(action)
        if (action == 'confirm') {
          that.reset();
        }
      });
    },
    /**
     * 重置
     */
    reset: function () {
      let that = this;
      that.bedNum = ''; //当前选择的bed
      that.bxTel = '';
      that.wentiDes = '';
      that.bxLocation = '';
      that.gzList.forEach(element => {
        element.isChoose = false;
      });
    },
    /**
     * 提交
     */
    submit: function () {
      let that = this
      if (!this.bedNum && this.selected == 1) {
        Toast("请选择床位");
        return;
      }
      if (!this.bxLocation && this.selected == 2) {
        Toast("请填写报修位置");
        return;
      }
      if (!this.bxTel) {
        Toast("请填写联系电话");
        return;
      }else {
        if (!checkPhone(this.bxTel)) {
          Toast("请填写正确的手机号");
          return;
        }
      }
      //故障描述
      let reportCause = [];
      this.gzList.forEach(element => {
        if (element.isChoose) {
          reportCause.push(element.name)
        }
      });
      if (reportCause.length == 0) {
        Toast("请选择故障");
        return;
      }
      //报修位置
      let location = this.selected == 1 ? this.initMaintainIndex.address + '-' + this.initMaintainIndex.roomNo + '-' + this.bedNum + '号床' : this.bxLocation;
      let wiredName = this.wired == 'wired' ? '有线' : '无线';
      reportCause =  wiredName + '---' + reportCause.join(',')
      let params = {
        indexType: this.selected,//1：宿舍报修，2：一般报修
        reporterName: this.initMaintainIndex.personName, //报修人姓名
        reporterNumber: this.initMaintainIndex.personNo, //报修人学号/工号
        reportCause: reportCause, //报修原因
        location: location, //报修位置
        reportCauseDescription: this.wentiDes, //报修原因描述
        reporterPhone: this.bxTel, //报修人联系方式
      }
      console.log(params)
      this.$store.dispatch("setLoadingState", true);
      service
      .maintainApply(params)
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        if (res.success) {
          that.reset();
          // Toast(res.msg);
          //跳转到我的报修菜单栏
          this.selected = 3;
        }
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    //页面跳转
    openPage: function (pageName, item) {
      console.log(item)
      this.$router.push({name: pageName, query: {pageDate: item}});
    },
    //弹出框 回调函数
    mesBosChange: function (data) {
      console.log(data);
      console.log("当前选择的item--", this.itemDate);
      this.showMesBox = false;
      if (data.typeName == '满意度') {
        this.cancelApply(this.itemDate, '/api/NetworkMaintain/doCompleteReportOrder', {"name": '满意度', "data": data})
      }
    },
    //操作按钮
    closeItem: function (event, type, item) {
      if(event) { 
        event.stopPropagation ? event.stopPropagation(): event.cancelBubble = true;
      }
      console.log(type)
      console.log(item)
      let that = this
      MessageBox.confirm('确定执行此操作?').then(action => {
        console.log(action)
        if (action == 'confirm') {
          if (type == '撤销申请') {
            that.cancelApply(item, '/api/NetworkMaintain/cancelApply', {"name": '撤销申请'})
          }
          if (type == '未修好') {
            that.cancelApply(item, '/api/NetworkMaintain/doNotRepairComplete', {"name": '未修好'})
          }
          if (type == '确认完成') {
            that.mesBoxTitle = {
              title: '满意度',
              subTitle: ''
            }
            that.mesBoxType = 6;
            that.showMesBox = true;
            that.itemDate = item;
          }
        }
      });
    },
    /**
     * 撤销申请
     */
    cancelApply: function (item, url, typeData) {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      let params = {
        id: item.id
      }
      if (typeData.name == '满意度') {
        params.isSatisfied = typeData.data.reason.name;
        params.satisfiedRemark = typeData.data.remarks;
      }
      console.log(params);
      api.post(url, params)
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        Toast(res.msg);
        if (res.success) {
          that.reset();
          that.loadTop();
        }
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    loadBottom: function(){//上拉加载更多
      console.log("上拉加载更多");
      this.more();                 
      this.$refs.loadmore.onBottomLoaded();
    },
    loadTop: function(){//下拉刷新
      this.pageNo = 1;
      this.loaddata();               
      this.$refs.loadmore.onTopLoaded();
    },
    more() {
      // 分页查询
      this.pageNo++;
      this.loaddata();
    },
    loaddata(){ //加载数据从vuex中拿数据

      if (this.selected == 3) {
        this.getDatas();
      }

    },
    getDatas() {
      this.$store.dispatch("setLoadingState", true);
      service
      .myNetWorkMaintain({
        "page": this.pageNo,
        "limit": this.pageSize
      })
      .then(res => {
        console.log(res);
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {
          let listArr = result.rows;

          if (this.pageNo == 1) {
            this.list = listArr;
            this.allLoaded = result.isLastPage;
          } else{
              this.list = this.list.concat(listArr);
              this.allLoaded = result.isLastPage;
          }
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
$gridCell-height: px2rem(70px);
$mes-height: px2rem(120px);
$other-height: px2rem(180px);
$cutLine-height: px2rem(20px);

$content1Height: px2rem(120px);
$content2Height: px2rem(200px);
.font-size-14px {
  font-size: 14px !important;
}
.mint-tab-item-label {
  font-size: 14px !important;
}
.checkInQuery {
  .fixed-content {
    height: 50px !important;
  }
  .tabContent {
    margin-bottom: px2rem(130px);
  }
  .scroll-content1 {
    top: calc(#{$content1Height}) !important;
  }
}
.cut-line {
  height: $cutLine-height;
  background: #f5f5f5;
}
.subTitle {
  font-size: 14px;
  padding: px2rem(20px);
  font-weight: bold;
}
.HqTextarea {
  width: px2rem(500px);
  height: px2rem(60px);
  border-radius: px2rem(15px);
  padding: px2rem(20px);
  border: none;
}

.item-input {
  background: #fff;
  padding: px2rem(25px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: px2rem(10px);
  margin-top: px2rem(15px);
  .label {
    font-size: 14px;
    color: #333;
  }
  .input-text {
    flex: 1;
    text-align: right;
    font-size: 14px;
  }
}
.dropdownBox {
  margin-left: px2rem(20px);
  display: flex;
  align-items: center;
  padding: 0 px2rem(5px);
  justify-content: flex-end;
  .dropdown {
    width: px2rem(250px);
  }
  .dropArrow {
    width: px2rem(40px);
    height: px2rem(40px);
  }
}
.gzBoxs {
  display: flex;
  flex-flow: row wrap;
  margin-left: px2rem(40px);
  .box {
      padding: px2rem(10px);
      background: #ddd;
      text-align: center;
      font-size: 14px;
      margin: px2rem(10px);
      color: #a0a0a0;
    }
}

.rooms {
  width: px2rem(550px);
  height: px2rem(200px);
  background: #fff;
  border: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: px2rem(20px);
  margin-left: px2rem(40px);
  .textDes {
    // width: px2rem(80px);
    flex-basis: px2rem(60px);
    padding: px2rem(10px);
    text-align: center;
    font-size: 12px;
  }
  .allBed {
    flex: 1;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
    height: px2rem(200px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: row wrap;
    padding: 0 px2rem(30px);
    .bed {
      width: 28%;
      padding: px2rem(10px);
      // height: px2rem(50px);
      // line-height: px2rem(50px);
      background: #ddd;
      text-align: center;
      font-size: 14px;
      margin: px2rem(10px);
      color: #a0a0a0;
    }
  }
}
.flex-1 {
  flex: 1;
}
.flex-basis-60 {
  flex-basis: px2rem(110px) !important;
  padding: 0 px2rem(10px);
}
.footerBtn {
  width: 100%;
  height: px2rem(80px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  position: fixed;
  bottom: 0;
  z-index: 99;
  .btn {
    width: 50%;
    text-align: center;
    height: px2rem(80px);
    line-height: px2rem(80px);
  }
}
.checkInQuery .tabBtn .navBar .tabBtnNav1 {
  padding: px2rem(30px) 0 !important;
  font-size: 14px;
}
.mobileSelect .content .btnBar .cancel, 
.mobileSelect .content .btnBar .ensure {
  font-size: 14px;
}
.mint-loadmore-text {
  font-size: 14px;
}
.mint-msgbox-btn {
  font-size: 14px;
}
.titleMes {
  display: flex;
  text-align: left;
  .leftMes {
    width: px2rem(300px);
    margin-right: px2rem(30px);
    text-align: left;
  }
  .rightMes {
    text-align: left;
  }
}
.listBox {
  .bg-f9b625 {
    background: #f9b625 !important;
  }
  display: flex;
  position: relative;
  .typeStateBtn {
    position: absolute;
    top: 0;
    right: 0;
    padding: px2rem(10px) px2rem(20px);
    border-radius: px2rem(10px);
    background: #e6e6e6;
  }
  //缩略图
  .thumbnail {
      width: px2rem(136px);
      height: px2rem(136px);
      margin-right: px2rem(30px);
      border-radius: px2rem(5px);
  }
  //缩略图-长方形
  .thumbnail-max {
      width: px2rem(210px);
      height: px2rem(136px);
      margin-right: px2rem(26px);
      border-radius: px2rem(5px);
  }
  //基本信息栏
  .mesList {
      flex: 1;
      .title {
          display: flex;
          align-items: center;
          flex: 1;
          //列表 标签
          .label {
              flex: none;
              display: inline-block;
              padding: 0 px2rem(15px);
              height: px2rem(32px);
              line-height: px2rem(32px);
              color: #fff;
              border-radius: px2rem(3px);
              margin-right: px2rem(16px);
              margin-left: px2rem(20px);
              font-size: px2rem(22px);
          }
      }
      //标签靠右-标签
      .title-label-right {
          justify-content: space-between;
      }
      p {
          color: #666;
          font-size: px2rem(26px);
          margin-top: px2rem(25px);
      }
  }
}

</style>


// WEBPACK FOOTER //
// RepairApply.vue?1a665e77